import React from 'react'

export const EnabledIntegrationsContext = React.createContext<Record<string, boolean | undefined>>(
  {}
)
